import type { ColumnType, Generated, Selectable } from 'kysely'
import z from 'zod'

import {
  docVersionSchema,
  namespaceSchema,
  nanoidSchema,
  slugSchema,
} from '@/utility'

export type DocumentEntity = {
  id: Generated<string>
  uid: string
  slug: string
  teamUid: string | null
  namespace: string
  isPrivate: boolean
  title: string
  description: string
  logoUrl: string | null
  searchEnabled: boolean
  currentVersion: string
  latestVersion: string
  curated: ColumnType<boolean, boolean | undefined>
  createdAt: ColumnType<Date, Date | undefined, never>
  updatedAt: ColumnType<Date, never, Date>
  documentSearch: Generated<unknown>
}

export type Document = Omit<Selectable<DocumentEntity>, 'documentSearch'>

export const documentSchema = z
  .object({
    id: z.uuid(),
    uid: nanoidSchema,
    slug: slugSchema,
    teamUid: nanoidSchema.nullable(),
    namespace: namespaceSchema,
    isPrivate: z.boolean(),
    title: z.string(),
    description: z.string(),
    logoUrl: z.url().nullable(),
    searchEnabled: z.boolean(),
    currentVersion: docVersionSchema,
    latestVersion: docVersionSchema,
    curated: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
  })
  .meta({ id: 'document' }) satisfies z.ZodType<Document>
